import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface TimeoutModalState {
  show: boolean;
  timeoutMessage: string;
  title: string;
  getRemainingTime: () => number;
  onTimeout: () => void;
  onStayLoggedIn: () => void;
}

const initialState: TimeoutModalState = {
  show: false,
  timeoutMessage:
    "Your session is about to expire in 5 seconds due to inactivity.",
  title: "Session Timeout.",
  getRemainingTime: () => 0,
  onTimeout: () => {},
  onStayLoggedIn: () => {},
};

export const timeoutModalSlice = createSlice({
  name: "timeoutModal",
  initialState,
  reducers: {
    /** display the given timeout message */
    showTimeoutMessage: (state, action: PayloadAction<any>) => {
      state.show = true;
      state.getRemainingTime = action.payload.getRemainingTime;
      state.onTimeout = action.payload.onTimeout;
      state.onStayLoggedIn = action.payload.onStayLoggedIn;
    },
    closeTimeoutModal: (state) => {
      state.show = false;
    },
  },
});

export const { showTimeoutMessage, closeTimeoutModal } = timeoutModalSlice.actions;

export const selectTimeoutModal = (state: RootState) => state.timeoutModal;

export default timeoutModalSlice.reducer;
